// Authentication endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: 'oauth/token',
    REFRESH: 'oauth/token-refresh',
    GET_USER: 'users/getUserByUsername/',
    GET_PERMISSIONS: 'users/getPermissions/',
  },

  // Activity Log
  ACTIVITY_LOG: {
    GET_LOGS: 'activityLogRest/getActivityLog', // GET
    GET_LOGS_COUNT: 'activityLogRest/count', // GET
  },

  // Client
  CLIENT: {
    LIST: 'client/', // GET (all clients, paginated, or with search params)
    LIST_BY_CODE: 'client/', // GET (with search and pagination)
    COUNT: 'client/count', // GET
    CREATE: 'client/', // POST
    SETTINGS: 'clientSettings/', // GET
    UPDATE_SETTING: 'clientSettings/', // PUT
    ADD_SETTING: 'clientSettings/', // POST - add new client setting
  },

  // Client Translation
  CLIENT_TRANSLATION: {
    LIST: 'translationMapper/', // GET
    COUNT: 'translationMapper/count', // GET
    ALL_CODES: 'translationMapper/', // GET (for dropdown - all codes for all clients)
    DATA: 'clientTranslation/', // GET
    DATA_COUNT: 'clientTranslation/count', // GET
    CREATE: 'translationMapper/', // POST
    UPDATE: 'translationMapper/', // PUT
    DELETE: 'translationMapper/', // DELETE
    DATA_CREATE: 'clientTranslation/', // POST
    DATA_UPDATE: 'clientTranslation/', // PUT
    DATA_DELETE: 'clientTranslation/', // DELETE
  },

  // Clone Job
  CLONE_JOB: {
    LIST: 'jobDetailRest/getJobDetail', // GET
    COUNT: 'jobDetailRest/count', // GET
    CREATE: 'jobDetailRest/cloneJob', // POST
    UPDATE: 'jobDetailRest/updateJobDetail', // PUT
    DELETE: 'jobDetailRest/deleteJobDetail', // DELETE
    EXECUTE: 'jobDetailRest/invokeJob', // POST
    CLONE: 'jobDetailRest/cloneJob', // POST - for cloning jobs
  },

  // Job Detail Edit
  JOB_DETAIL_EDIT: {
    GET_BY_ID: 'jobDetailRest/{id}', // GET - Get job by ID
    GET_ENUMS: 'jobDetailRest/getJobDetailEnums', // GET - Get enums
    UPDATE: 'jobDetailRest/updateJobDetail', // PUT - Update job
    START_JOB: 'jobDetailRest/startJob/{id}', // POST - Start job
    INVOKE_GET: 'invoke', // GET - Invoke/start job (response "ok" = triggered)
  },

  // Error Pattern
  ERROR_PATTERN: {
    LIST: 'errorPatternMaster/', // GET
    COUNT: 'errorPatternMaster/count', // GET
    CREATE: 'errorPatternMaster/', // POST
    UPDATE: 'errorPatternMaster/', // PUT
    DELETE: 'errorPatternMaster/', // DELETE
    ENUMS: 'errorPatternMaster/getErrorPatternEnums', // GET
  },

  // Failure Mail Config
  FAILURE_MAIL_CONFIG: {
    LIST: 'failureMailConfigRest/', // GET (with params)
    COUNT: 'failureMailConfigRest/count', // GET
    CREATE: 'failureMailConfigRest/', // POST
    UPDATE: 'failureMailConfigRest/', // PUT
    DELETE: 'failureMailConfigRest/', // DELETE
    ERROR_PATTERNS: 'errorPatternMaster', // GET
  },

  // Global Variable
  GLOBAL_VARIABLE: {
    LIST: 'oipGlobalVariableRest', // GET list of global variables
    COUNT: 'oipGlobalVariableRest/count', // GET count of global variables
    UPDATE: 'oipGlobalVariableRest/', // PUT update global variable
    CREATE: 'oipGlobalVariableRest/', // POST create global variable
    DELETE: 'oipGlobalVariableRest/', // DELETE global variable by id
  },

  // Integration
  INTEGRATION: {
    FAILURES: 'integrationInstanceFailureRest/getIntegrationFailure', // GET (list, paginated, filtered)
    FAILURE_COUNT: 'integrationInstanceFailureRest/count', // GET
    FAILURE_DETAIL: 'integrationInstanceFailureRest/getIntegrationFailure', // GET (by id)
    FAILURE_DETAIL_COUNT: 'integrationInstanceFailureRest/count', // GET
    ERROR_PATTERN: 'errorPatternMaster/', // GET (list, filtered)
  },

  // Job
  JOB: {
    DETAIL_LIST: 'jobDetailRest/getJobDetail', // GET (list, paginated, filtered)
    DETAIL_LIST_BY_CODE: 'jobDetailRest/getJobDetail', // GET (list, paginated, filtered)
    DETAIL_COUNT: 'jobDetailRest/count', // GET
    DETAIL_COUNT_BY_CODE: 'jobDetailRest/count', // GET
    CREATE: 'jobDetailRest/createJobDetail', // POST
    DETAIL_BY_ID: 'jobDetailRest/getJobDetail', // GET (by id)
    UPDATE: 'jobDetailRest/updateJobDetail', // PUT
    STEP_DETAIL: 'stepDetailRest/getStepDetail', // GET
    UPDATE_STEP_DETAIL: 'stepDetailRest/updateStepDetail', // PUT
    JOB_SETTINGS: 'jobSettings/getJobSetting', // GET
    JOB_SETTING_UPDATE: 'jobSettings/', // PUT
    JOB_SETTING_CREATE: 'jobSettings/', // POST
    JOB_SETTING_DELETE: 'jobSettings/', // DELETE (by id) - backend in development
    JOB_SETTING_KEYS: 'jobSettings/getAllKeys', // GET
    MAIL_SETTINGS: 'mailSettingsRest/', // GET (list or by jobDetailId)
    MAIL_SETTING_UPDATE: 'mailSettingsRest/', // PUT
    MAIL_SETTING_CREATE: 'mailSettingsRest/', // POST
    MAIL_SETTING_DELETE: 'mailSettingsRest/', // DELETE (by id)
    STEP_SETTINGS: 'stepSettings/getStepSetting', // GET
    UPDATE_STEP_SETTING: 'stepSettings/updateStepSetting', // PUT
    STEP_SETTING_CREATE: 'stepSettings/', // POST
    STEP_SETTING_UPDATE: 'stepSettings/', // PUT
    STEP_SETTING_DELETE: 'stepSettings/', // DELETE (by id)
    STEP_REQUEST_VALIDATOR: 'stepRequestValidatorRest/getStepRequestValidator', // GET
    STEP_REQUEST_VALIDATOR_LIST: 'stepRequestValidatorRest/', // GET (list with stepId filter)
    STEP_REQUEST_VALIDATOR_ENUMS: 'stepRequestValidatorRest/getstepRequestEnums', // GET
    STEP_REQUEST_VALIDATOR_CREATE: 'stepRequestValidatorRest/', // POST
    STEP_REQUEST_VALIDATOR_UPDATE: 'stepRequestValidatorRest/', // PUT
    STEP_REQUEST_VALIDATOR_DELETE: 'stepRequestValidatorRest/', // DELETE (by id)
    INVOKE: 'jobDetailRest/invokeJob', // POST
    JOB_RUN_LIST: 'jobRunRest/getJobRun', // GET
    JOB_RUN_COUNT: 'jobRunRest/count', // GET
    JOB_RUN_DETAIL_LIST: 'jobRunDetailRest/', // GET - for job run details with filters
    JOB_DETAIL_ENUMS: 'jobDetailRest/getJobDetailEnums', // GET
    JOBS_FOR_CLIENT: 'jobDetailRest/getJobDetail', // GET (for combobox)
    JOB_COUNT_FOR_CLIENT: 'jobDetailRest/count', // GET
    JOBS_FOR_CLONE: 'jobDetailRest/getJobDetail', // GET
    JOBS_COUNT_FOR_CLONE: 'jobDetailRest/count', // GET
    CLONE: 'jobDetailRest/cloneJob', // POST
    JOB_NAMES_FOR_CLIENT: 'jobDetailRest/getJobDetail', // GET
    ERROR_PATTERN_LIST: 'jobErrorPatternRest/getJobErrorPattern', // GET
    ERROR_PATTERN_COUNT: 'jobErrorPatternRest/count', // GET
    UPDATE_ERROR_PATTERN: 'jobErrorPatternRest/updateJobErrorPattern', // PUT
    CREATE_ERROR_PATTERN: 'jobErrorPatternRest/createJobErrorPattern', // POST
    JOB_ACTIVITY_LOG_LIST: 'jobActivityLogRest/getJobDetail', // GET
    JOB_ACTIVITY_LOG_COUNT: 'jobActivityLogRest/count', // GET
    // Step endpoints
    STEP_LIST: 'stepRest/getStep', // GET (list, paginated, filtered)
    STEP_ENUMS: 'stepRest/getStepEnums', // GET
    STEP_CREATE: 'stepRest/', // POST (create step)
    STEP_UPDATE: 'stepRest/', // PUT (update step)
  },

  // Jobs (alias for JOB for backward compatibility)
  JOBS: {
    RUN: 'jobRunRest/getJobRun', // GET
    STEP_HISTORY: 'stepHistoryRest/getStepHistory', // GET
    STEP_HISTORY_COUNT: 'stepHistoryRest/count', // GET
    STEP_HISTORY_ENUMS: 'stepHistoryRest/getStepHistoryEnums', // GET
    STEP_HISTORY_DETAIL: 'stepHistoryRest/getStepHistory', // GET by ID
    STEP_HISTORY_ELASTIC: 'stepHistoryElasticRest/getStepHistory', // GET
    STEP_HISTORY_ELASTIC_COUNT: 'stepHistoryElasticRest/count', // GET
    STEP_HISTORY_ELASTIC_ENUMS: 'stepHistoryElasticRest/getStepHistoryEnums', // GET
    SYSTEM_JOB: 'systemJobDetailRest', // GET
    SYSTEM_JOB_DETAIL: 'systemJobDetailRest', // GET
    CLONE_JOB_DETAIL: 'jobDetailRest/getJobDetail', // POST
  },

  // Mail
  MAIL: {
    ENUMS: 'mailRest/getMailEnums', // GET
    LIST: 'mailRest', // GET (with params: pagination, filtering)
    COUNT: 'mailRest/count', // GET
    CONFIG: 'failureMailConfigRest', // GET
  },

  // Parse Template
  PARSE_TEMPLATE: {
    PARSE: 'public/parseTemplate', // POST
  },

  // Roles (alias for USER for backward compatibility)
  ROLES: {
    LIST: 'role/', // GET
    COUNT: 'role/count', // GET
    CREATE: 'role/', // POST
    UPDATE: 'role/', // PUT
    ROLE_BY_ID: 'role', // GET by id -> /role/{id}
    PERMISSIONS: 'permission/', // GET
    ROLE_PERMISSIONS: 'rolePermission/', // GET
    SAVE_ROLE_PERMISSIONS: 'rolePermission/saveRolePermission', // POST
  },

  // Script Tester
  SCRIPT_TESTER: {
    TEST: 'public/scriptTester', // POST
  },

  // System Job
  SYSTEM_JOB: {
    LIST: 'systemJobDetailRest', // GET (with params: pagination, filtering)
    COUNT: 'systemJobDetailRest/count', // GET
    CREATE: 'systemJobDetailRest', // POST
    UPDATE: 'systemJobDetailRest', // PUT
    DELETE: 'systemJobDetailRest', // DELETE
    EXECUTE: 'systemJobDetailRest/execute', // POST
  },

  // Translation
  TRANSLATION: {
    CODES: 'translationMapper/', // GET (with params: clientId)
    HEADERS: 'translationMapper/', // GET (with params: code)
    TABLE_DATA: 'clientTranslation/', // GET (with params: code)
    MAPPER: 'translationMapper/', // GET
    CLIENT_TRANSLATION: 'clientTranslation/', // GET
    DELETE_CLIENT_TRANSLATION: 'clientTranslation/deleteWithBigInteger', // POST
    CREATE_CLIENT_TRANSLATION: 'clientTranslation/', // POST
    UPDATE_CLIENT_TRANSLATION: 'clientTranslation/', // PUT
  },

  // User
  USER: {
    LIST: 'users/', // GET (list, paginated, filtered)
    COUNT: 'users/count', // GET
    BY_ID: 'users/{id}', // GET User by id
    UPDATE: 'users/', // PUT
    CREATE: 'users/', // POST
    SAVE_USER_ROLE: 'userRole/saveUserRole', // POST
    UPDATE_USER_ROLES: 'userRole/updateUserRoles', // PUT
    USER_ROLES: 'userRole/', // GET ?firstResult=-1&maxResult=0&userId={userId}
    ROLES_LIST: 'role/', // GET
    CREATE_ROLE: 'role/', // POST
    UPDATE_ROLE: 'role/', // PUT
    ROLE_BY_ID: 'role/{roleId}', // GET
    PERMISSIONS: 'permission/', // GET
    ASSIGNED_PERMISSIONS: 'rolePermission/', // GET
    SAVE_ROLE_PERMISSIONS: 'rolePermission/saveRolePermissions', // POST
  },

  // Online Template
  ONLINE_TEMPLATE: {
    PARSE_TEMPLATE: 'public/parseTemplate', // POST
    SCRIPT_TEMPLATE: 'public/scriptTester', // POST
  },
} as const;

// Helper function to get endpoint with client code
export function getEndpoint(clientCode: string, endpoint: string): string {
  return `/${clientCode}/${endpoint}`;
}

// Helper function to get endpoint with ID
export function getEndpointWithId(clientCode: string, endpoint: string, id: string | number): string {
  return `/${clientCode}/${endpoint}/${id}`;
} 